module.exports = __webpack_public_path__ + "static/media/wide.c974ee68.jpg";